export default {
    CustomerList: {
        ChooseCustomer: 'Velg kunde',
    },

    Customer: {
        SafesOnline: 'Maskiner online',
        CurrentBalance: 'Nåværende beholdning',
        DailySales: 'Dagens innskudd',
        ActiveWarnings: 'Varsler',
        Of: 'Av',
        In: 'I',
        Branches: 'BUTIKKER',
    },

    Branch: {
        ExportTransactions: "Eksporter transaksjoner",
        ManageOperators: "Endre brukere",
        ShowOnMap: "Vis på kart",
        CurrentBalance: "Nåværende beholdning",
        DailySales: 'Dagens innskudd',
        MainCurrency: 'Hovedvaluta',
        TransactionDays: "Transaksjonsdager"
    },

    BranchList: {
        Name: 'Navn',
        Status: 'Status',
        BalanceAmount: 'Beholdning',
        BalanceCurrency: 'Valuta',
        LastBalance: 'Oppdatert',
        Branches: 'Butikker',
    },

    BranchListFilter: {
        Branches: 'Butikker',
        SearchCriteria: 'Finn butikk...',
    },

    Chart: {
        Sales: 'Innskudd',
        Pickup: 'Tømming',
        Balance: 'Beholdning',
        Difference: 'Avvik',
        Confirmed: 'Bekreftet',
        SalesBalancesAndPickups: 'Innskudd, beholdning og tømminger',
        NoDataAvailable: 'Data ikke tilgjengelig',
        SafebagBalance: 'Transportpose',
        RecyclableBalance: 'Resirkulerbar beholdning',
        ManualDepositBalance: 'Manuelle innskudd beholdning',
        OverflowBalance: 'Overskuddsbeholdning'
    },

    ChartDenominations: {
        Deposited: 'Deponert ikke resirkulerbart',
        Recyclable: 'Resirkulerbart',
        Denominations: 'Valører',
        NoDataAvailable: 'Ingen data tilgjenglig'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Dagsomsetning deponert automat',
        UnprocessedSales: 'Dagsomsetning deponert manuelt',
        SalesOut: 'Uttak fra dagsomsetning',
        SalesPerHour: 'Omsetning per time'
    },

    CustomerHeader: {
        ShowOnMap: 'Vis på kart',
        Branches: 'Butikker',
        Branch: 'Butikk',
        ExportTransactions: 'Transaksjoner',
    },

    DeviceStatus: {
        AllOk: 'OK',
    },

    DeviceStatusList: {
        Safes: 'Maskiner',
    },

    ExportForm: {
        ExportTransactions: 'Eksporter transaksjoner',
        Cancel: 'Avbryt',
        Export: 'Eksporter',
        FromDate: 'Fra',
        Time: 'Tid',
        EndDate: 'Til'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Glemt passordet?',
        ForgotText: 'Vennligst skriv inn emailen din nedenfor og klikk på knappen. Du vil motta en epost med ytterligere instruksjoner.',
        LoginLink: 'Tilbake til innlogging',
        EmailAddress: 'E-mail addresse',
        Submit: 'Send e-mail',
        ErrorMessage: 'Kunne ikke sende forespørsel til server'
    },

    LoginPage: {
        LoginHeader: 'Velkommen',
        LoginText: 'Logg inn nedenfor ved hjelp av e-post og passord',
        LoginForgot: 'Glemt passordet?',
        Username: 'E-POST',
        Password: 'PASSORD',
        Login: 'Logg Inn'
    },

    ResetPasswordPage: {
        ResetHeader: 'Tilbakestille passord',
        ResetText: 'Skriv inn ditt nye passord.'
    },

    Drawer: {
        Dashboard: 'Oversikt',
        SwitchCustomer: 'Bytt kunde',
        MyProfile: 'Min profil',
        Logout: 'Logg ut'
    },

    OperatorForm: {
        UserId: 'Bruker-id',
        FirstName: 'Fornavn',
        LastName: 'Etternavn',
        Pin: 'Pin',
        Save: 'Lagre',
        Delete: 'Fjern',
        Operator: 'Operatør'
    },

    OperatorList: {
        AddOperator: 'Legg til bruker',
        Operators: 'Brukere',
        Name: 'Navn'
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Navn',
        Language: 'Språk',
        Password: 'Passord',
        ConfirmPassword: 'Bekreft passord',
        Update: 'Lagre'
    },

    ResetPasswordForm: {
        NewPassword: 'Nytt passord',
        ConfirmPassword: 'Bekreft passord',
        Submit: 'Lagre'
    },

    InviteUserForm: {
        InviteHeader: 'Bruker profil',
        InviteText: 'Vennligst fyll ut etterspurt bruker data, trykk Lagre. Bruker profil er nå opprettet og påloggsinformasjon er sendt til oppgitt e-post adresse.',
        Name: 'Navn',
        Language: 'Språk',
        NewPassword: 'Nytt passord',
        ConfirmPassword: 'Bekreft passord',
        Submit: 'Lagre'
    },

    TransactionList: {
        Type: 'Type',
        Operator: 'Bruker',
        When: 'Tidspunkt',
        Amount: 'Beløp',
        Currency: 'Valuta',
        Transactions: 'Transaksjoner',
        Device: 'Maskin',
        SalesDay: 'Oppgjørsdato',
        HoverDeposit: 'Innskudd',
        HoverSalesIn: 'Dagsomsetning',
        HoverSalesOut: 'Uttak',
        HoverManualDeposit: 'Manuelt innskudd',
        HoverCollection: 'Tømming',
        HoverCollectionNotes: 'Tømming av sedler',
        HoverCollectionCoins: 'Tømming av mynt',
        HoverCollectionEnvelope: 'Tømming av manuelle innskudd',
        HoverCollectionOK: 'Bekreftet tømt',
        HoverCollectionNotesOK: 'Bekreftet tømt (sedler)',
        HoverCollectionCoinsOK: 'Bekreftet tømt (mynt)',
        HoverCollectionEnvelopeOK: 'Bekreftet tømt (manuelle innskudd)',
        HoverCollectionNOK: 'Avvik',
        HoverCollectionNotesNOK: 'Avvik sedler',
        HoverCollectionCoinsNOK: 'Avvik mynt',
        HoverCollectionEnvelopeNOK: 'Avvik manuelle inskudd',
        HoverDrain: 'Flytt/Tøm verdier fra rull/hopper',
        HoverRefill: 'Påfyll',
        HoverExchange: 'Veksling',
        HoverExchangeIn: 'Veksling inn',
        HoverExchangeOut: 'Veksling ut',
        HoverCounterfeit: 'Falske sedler/mynt',
        HoverInternal: 'Intern transaksjon',
        HoverNOP: 'Ingen hendelse'
    },

    TransactionDayList: {
        Date: "Dato",
        Sales: "Omsetning",
        Pickup: "Tømming",
        Balance: "Beholdning",
        TransactionDays: "Transaksjonsdager"
    },

    TransactionDay: {
        Date: "Dato",
        Sales: "Omsetning",
        Pickup: "Tømming",
        Balance: "Beholdning",
        TransactionDays: "Transaksjonsdager",
        ExportTransactions: 'Eksporter transaksjoner'
    },

    TransactionDatePicker: {
        Date: 'Dato'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/no.js